/* Ayudate · Campo de teléfono con código de país
   El select de código va aparte del número: así el número nunca lleva un
   "+" ni el prefijo mezclado adentro. El número filtra al toque cualquier
   cosa que no sea un dígito, y el tope de largo depende del país: Costa
   Rica (+506) usa el formato local de 8 dígitos, el resto de países de la
   lista conserva el rango más amplio (hasta 11) que ya cubre vTelefono.
   Si lo que se escribe o pega trae más dígitos que el tope, el sobrante
   simplemente no entra (igual que antes) pero ahora se avisa con una nota
   en vivo — antes se recortaba en silencio y nadie entendía por qué el
   campo "no dejaba escribir más". */

import React, { useState } from "react";
import { CODIGOS_PAIS } from "../datos/codigosPais";

const MAX_CR = 8;
const MAX_OTROS = 11;

export function TelefonoInput({
  id, codigo, onCodigoChange, valor, onValorChange, className = "",
  placeholder = "Teléfono o WhatsApp", ariaInvalid,
}) {
  const max = codigo === "+506" ? MAX_CR : MAX_OTROS;
  const [tope, setTope] = useState(false);

  return (
    <>
      <div className="tel-fila">
        <select className="in tel-cod" aria-label="Código de país" required
          value={codigo} onChange={(e) => {
            const nuevoCodigo = e.target.value;
            const nuevoMax = nuevoCodigo === "+506" ? MAX_CR : MAX_OTROS;
            onCodigoChange(nuevoCodigo);
            if (valor.length > nuevoMax) onValorChange(valor.slice(0, nuevoMax));
            setTope(false);
          }}>
          {CODIGOS_PAIS.map((c) => (
            <option key={c.pais} value={c.codigo}>{c.codigo} {c.pais}</option>
          ))}
        </select>
        <input id={id} className={`in tel-num ${className}`} type="tel" inputMode="numeric"
          pattern="[0-9]*" placeholder={placeholder}
          aria-label="Número de teléfono" aria-invalid={ariaInvalid}
          value={valor}
          onChange={(e) => {
            const digitos = e.target.value.replace(/\D/g, "");
            setTope(digitos.length > max);
            onValorChange(digitos.slice(0, max));
          }} />
      </div>
      {tope && <p className="ayuda mal tel-tope" role="alert">{`El máximo es ${max} dígitos.`}</p>}
    </>
  );
}
